import { en } from './en';
import { vi } from './vi';
export * from './translateCodes';

export const defaultLocale = {
    en,
    vi
};